var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CITFTimePicker',{attrs:{"show-status":true,"state":_vm.state,"value":_vm.value,"disabled":_vm.disabled,"clearable":false,"range":"","confirm":"","placeholder":"Select Time Range"},on:{"input":function($event){return _vm.$emit('input', $event)}}},[(false)?_c('template',{slot:"header"}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }